import styled from '../../../styles/theme';
import { StockCardStyled } from '../StockCardStyled';

export const StockCardStyledAP = styled(StockCardStyled)``;
